/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yearly_Plan_CnInputs */

const en_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const ar_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const de_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const es_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const fr_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const it_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const ja_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const ko_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const pt_br_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const ru_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const th_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const tr_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

const zh_cn_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一年`)
};

const zh_tw_yearly_plan_cn = /** @type {(inputs: Yearly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一年`)
};

/**
* | output |
* | --- |
* | "1 Year" |
*
* @param {Yearly_Plan_CnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const yearly_plan_cn = /** @type {((inputs?: Yearly_Plan_CnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yearly_Plan_CnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yearly_plan_cn(inputs)
	if (locale === "ar") return ar_yearly_plan_cn(inputs)
	if (locale === "de") return de_yearly_plan_cn(inputs)
	if (locale === "es") return es_yearly_plan_cn(inputs)
	if (locale === "fr") return fr_yearly_plan_cn(inputs)
	if (locale === "it") return it_yearly_plan_cn(inputs)
	if (locale === "ja") return ja_yearly_plan_cn(inputs)
	if (locale === "ko") return ko_yearly_plan_cn(inputs)
	if (locale === "pt_br") return pt_br_yearly_plan_cn(inputs)
	if (locale === "ru") return ru_yearly_plan_cn(inputs)
	if (locale === "th") return th_yearly_plan_cn(inputs)
	if (locale === "tr") return tr_yearly_plan_cn(inputs)
	if (locale === "zh_cn") return zh_cn_yearly_plan_cn(inputs)
	return zh_tw_yearly_plan_cn(inputs)
});